exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] ._2Iqc9ATQuN1sn_-qUo8zM6{padding-top:20px}", ""]);
// Exports
exports.locals = {
	"userVoiceDisclaimerLabel": "_2Iqc9ATQuN1sn_-qUo8zM6"
};